if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (
          this.cart &&
          (typeof this.cart.getSectionsToRender !== 'function' ||
            typeof this.cart.setActiveElement !== 'function' ||
            typeof this.cart.renderContents !== 'function')
        ) {
          this.cart = null;
        }
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        let addSucceeded = false;
        this.lastSubmitter = evt.submitter instanceof HTMLElement ? evt.submitter : this.submitButton;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const cartDrawer = document.querySelector('cart-drawer');
        if (!this.cart && cartDrawer) {
          this.cart = cartDrawer;
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            addSucceeded = true;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            if (addSucceeded) this.playAddSuccessFeedback();

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      playAddSuccessFeedback() {
        const affectedButtons = [];
        const ADD_SUCCESS_MS = 2000;

        const setAddedState = (button, labelNode, labelText) => {
          if (!button) return;

          if (labelNode) {
            labelNode.textContent = 'Added';
          } else {
            button.textContent = 'Added';
          }

          button.classList.remove('is-added');
          void button.offsetWidth;
          button.classList.add('is-added');
          button.setAttribute('aria-disabled', 'true');

          affectedButtons.push({ button, labelNode, labelText });
        };

        const defaultMainLabel = this.submitButtonText ? this.submitButtonText.textContent.trim() : '';
        setAddedState(this.submitButton, this.submitButtonText, defaultMainLabel);

        if (this.form && this.form.id) {
          document.querySelectorAll('[data-sticky-atc-btn]').forEach((button) => {
            if (button.getAttribute('form') === this.form.id) {
              const stickyLabel = button.textContent.trim();
              setAddedState(button, null, stickyLabel);
            }
          });
        }

        window.clearTimeout(this.addedStateTimer);
        this.addedStateTimer = window.setTimeout(() => {
          affectedButtons.forEach(({ button, labelNode, labelText }) => {
            button.classList.remove('is-added');
            if (!button.disabled) {
              button.removeAttribute('aria-disabled');
            }
            if (labelNode) {
              labelNode.textContent = labelText;
            } else if (labelText) {
              button.textContent = labelText;
            }
          });
        }, ADD_SUCCESS_MS);

        this.dispatchEvent(
          new CustomEvent('loomforma:add-success', {
            bubbles: true,
            detail: {
              formId: this.form ? this.form.id : null,
              triggerButton: this.lastSubmitter || this.submitButton,
            },
          })
        );
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.removeAttribute('aria-disabled');
          delete this.submitButton.dataset.pendingLabel;
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
          delete this.submitButton.dataset.pendingLabel;
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
